import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_blue.css';
  // localization is optional
import {Korean} from 'flatpickr/dist/l10n/ko.js';
import { getFormatDate } from '@/utils/date_convert';  
import DisplayTime from '@/components/site/parts/DisplayTime.vue'
export const myRecommenderReward = {    
    data () {
      return {
        // Initial value can be a date object as well
        //date: '2020-10-16',
        date: getFormatDate(new Date()),
        // Get more form https://flatpickr.js.org/options/
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y년 M J',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Korean, // locale for this instance only     
          mode: "range"     
        },  
        isLoading:true,        
      }
    },
    mounted(){
        this.fetchLists();
    },
    components: {
      flatPickr,
      DisplayTime
    }, 
    computed:{
        pointLogs:{            
            get(){                 
                return this.$store.state.point.rewardLogs;
            }
        },
        rewardTotal:{            
            get(){                 
                return this.$store.state.point.rewardTotal;
            }
        },
        listSum(){
            const accumulator = {
                point_coupon: 0,
                change_nic: 0,
                post_write: 0,
                attendance: 0,
                comment_answer:0,
                recommend:0,
                total:0
            }    
            this.pointLogs.forEach(log => {
                accumulator.point_coupon += parseFloat(log.point_coupon);   
                accumulator.change_nic += parseFloat(log.change_nic);            
                accumulator.post_write += parseFloat(log.post_write);            
                accumulator.attendance += parseFloat(log.attendance);            
                accumulator.comment_answer += parseFloat(log.comment_answer);            
                accumulator.recommend += parseFloat(log.recommend);                        
            });
               accumulator.total =  accumulator.point_coupon + accumulator.change_nic 
               + accumulator.post_write + accumulator.attendance + accumulator.comment_answer
               + accumulator.recommend;
                return accumulator;
        }
    }, 
    methods:{  
        async fetchLists() {
            const formData = {               
                user_id:this.$store.getters.currentUser.id,
                searchDate:this.date,           
            }
            this.isLoading = true;
            try {
                const response = await this.$store.dispatch("point/getRewardLogs", formData);
                console.log(response);
                // this.pointLogs = response.data.logs.reverse();
                // this.total =  response.data.total;
                //console.log("안나오는듯",this.postlists.data.length);          
            }catch(error){
                console.log(error.response);
            }
            this.isLoading = false;
        },
      
    },
}